export const setError = (err: any) => {
  return {
    type: 'SET_ERROR',
    status: resolveErrorStatus(err)
  };
};

export const clearError = () => {
  return {
    type: 'SET_ERROR',
    status: null as number
  };
};

export function resolveErrorStatus(err: any) {
  if (!err) {
    return 500;
  }

  if (typeof err === 'number') {
    return err;
  }

  if (err.response && err.response.status) {
    return err.response.status;
  }

  const groups = /Request\sfailed\swith\sstatus\scode\s(\d+)$/gi.exec(err.message);
  if (groups && groups.length > 1) {
    return Number(groups[1]);
  }

  return 500;
}
